module.exports = __webpack_public_path__ + "img/9.fb7fd85d.png";